import type {ReactElement} from 'react';
import {ActionMenu} from '@Components/action-menu/action-menu';
import {Text, TextSize} from '@Components/text';
import type {EventWizardCoverMenuProps, EventWizardCoverMenuSection} from './event-wizard-cover-menu.types';
import styles from './event-wizard-cover-menu.module.scss';

/** The cover tile's menu: its rows in groups, each with an optional header, a divider between groups. */
export function EventWizardCoverMenu({sections, isMobile}: EventWizardCoverMenuProps): ReactElement {
  const sectionsWithItems = sections.filter((section) => {
    return section.items.length > 0;
  });

  const getSection = (section: EventWizardCoverMenuSection, index: number): ReactElement => {
    return (
      <div key={section.id} role="group" aria-label={section.header ?? undefined} className={index > 0 ? styles.coverMenuSectionAfterDivider : ''}>
        {section.header !== null ? <Text val={section.header} size={TextSize.XS} bold className={styles.coverMenuSectionHeader} /> : null}
        <ActionMenu isMobile={isMobile} items={section.items} />
      </div>
    );
  };

  return <div>{sectionsWithItems.map(getSection)}</div>;
}
